import React from "react";
import ContextMenuContentWrapper from "../common/ContextMenuContentWrapper";

const ExportItemChecklist = ({ options = [], onChange }) => {
  return (
    <ul className="export-item-checklist">
      {options.map((option, index) => (
        <li
          key={index}
          className="export-item-checklist-item"
          onClick={() => {
            if (option?.isRequired) {
              return;
            } else {
              onChange(index);
            }
          }}
          style={
            option?.isRequired
              ? { opacity: 0.65, cursor: "not-allowed" }
              : { opacity: 1, cursor: "pointer" }
          }
        >
          <input
            type="checkbox"
            id={option.value}
            name={option.value}
            checked={option?.isChecked || option?.isRequired}
            disabled={option?.isRequired}
            style={{
              cursor: "inherit",
            }}
            readOnly
          />
          <p
            onClick={(e) => {
              e.stopPropagation();
              if (option?.isRequired) {
                return;
              } else {
                onChange(index);
              }
            }}
            style={{
              cursor: "inherit",
            }}
          >
            {option.label}
          </p>
        </li>
      ))}
    </ul>
  );
};

const DynamicExportMenu = ({ isOpen, options, onChange, onClose }, ref) => {
  if (!isOpen) return null;
  return (
    <ContextMenuContentWrapper
      showContextMenu={isOpen}
      handleContextMenuClose={onClose}
    >
      <div ref={ref} className="export-item-checklist-form">
        <p className="export-item-checklist-title">Available Fields:</p>
        <ExportItemChecklist options={options} onChange={onChange} />
      </div>
    </ContextMenuContentWrapper>
  );
};

export default React.forwardRef(DynamicExportMenu);
